import axios from "@/lib/request";

export const login = (data) => {
  return axios.request({
    url: "/v1/admin/cmn/admin/login",
    method: "post",
    data,
  });
};

export const getInfo = () => {
  return axios.request({
    url: "/v1/admin/cmn/admin/info",
    method: "get",
    // appkey: true,
  });
};

export const getRoleList = (params) => {
  return axios.request({
    url: "/v1/admin/cmn/role/list",
    method: "get",
    params,
  });
};

export const getAdministratorList = (params) => {
  return axios.request({
    url: "/v1/admin/zaj/cmn/administrator/list",
    method: "get",
    params,
  });
};
export const getAdministratorInfo = (params) => {
  return axios.request({
    url: "/v1/admin/zaj/company/info",
    method: "get",
    params,
  });
};
export const getAdministratorAdd = (data) => {
  return axios.request({
    url: "/v1/admin/zaj/cmn/administrator/add",
    method: "post",
    data,
  });
};

export const getAdministratorUpdate = (data) => {
  return axios.request({
    url: "/v1/admin/zaj/cmn/administrator/update",
    method: "post",
    data,
  });
};
export const getAdministratorDisable = (data) => {
  return axios.request({
    url: "/v1/admin/zaj/cmn/administrator/disable",
    method: "post",
    data,
  });
};

export const updatePassword = (data) => {
  return axios.request({
    url: "/v1/admin/cmn/employee/update",
    method: "post",
    data,
  });
};



// 获取AccessToken
export const getAccessToken = (params) => {
  return axios.request({
    url: "/v1/admin/zaj/cmn/accesstoken",
    method: "get",
    params,
  });
};
export const getQrcode = (data) => {
  return axios.request({
    url: "/v1/admin/zaj/cmn/qrcode",
    method: "post",
    data,
  });
};
